import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { translate } from '../../../Services/translation';

const showValue = (value, typeName) => {
    switch (typeName) {
        case "Image":
            return !!value && value != "" ? <img src={`${window.location.origin}${value}`} /> : null
        case "Date":            
            const date = (new Date(value)).toLocaleDateString();
            return date !== '01.01.1' &&  date !== '1-01-01' ? date : "";
        default:
            return value;
    }
}

export const useTable = (getRequest, deleteRequest, updateLinkUrl, updateBlockLinkUrl, headers, model) => {
    const { systemId, forbidEditAction, forbidShowBlockAction, forbidDeleteAction } = model;
    const filteredHidders = headers.filter(({ isHiddenInIndex }) => !isHiddenInIndex);
    const headerNames = filteredHidders.map(({ headerName, typeName }) => [headerName, typeName]);
    const headeLabels = filteredHidders.map(({ label }) => label);
    const table_th = [translate("coptikk.adminportal.common.no") + " ", ...headeLabels];
    if (!(forbidEditAction && forbidDeleteAction && forbidShowBlockAction)) {
        table_th.push("Action");
    }
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const deletePage = (id) => () => {
        if (confirm(`Do you really want to delete this ${model.root}?`)) {
            deleteRequest([id]).then(() => {
                setData(data.filter((item) => item[systemId] !== id));
            });
        }
    }
    const updateTableData = () => {
        setLoading(true);
        getRequest().then((resp) => {
            setData(resp.map((item, i) => ({ ...item, _item_id: i + 1 })));
            setLoading(false);
        });
    }
    useEffect(() => {
        updateTableData();
    }, []);
    const result =
        <div className="backend__table">
            {loading ? (
                <div className="backend__loading">Loading ...</div>
            ) : (
                <table>
                    <thead>
                        <tr>
                            {table_th.map(th => <th key={th}>{th}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length && data.map(({ _item_id, ...fields }) =>
                            <tr key={fields[systemId]}>
                                <td>{_item_id}</td>
                                {headerNames.map(([headerName, typeName]) => <td key={`${fields[systemId]}-${headerName}`}>{showValue(fields[headerName], typeName)}</td>)}
                                {!(forbidEditAction && forbidDeleteAction && forbidShowBlockAction) ? <th>
                                    <div className="actions">
                                        {!forbidShowBlockAction ? <Link to={updateBlockLinkUrl(fields[systemId])}><i className="block" /></Link> : null}
                                        {!forbidEditAction ? <Link to={updateLinkUrl(fields[systemId])}><i className="edit" /></Link> : null}
                                        {!forbidDeleteAction ? <i className="delete" onClick={deletePage(fields[systemId])} /> : null}
                                    </div>
                                </th> : null}
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>

    return [result, updateTableData];
}